// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b015129b","142":"bcbb797e","441":"e12b24f7","456":"225c5ce0"}[chunkId] + ".chunk.css";
};